import React, { useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Chip from "@material-ui/core/Chip";
import SearchIcon from "@material-ui/icons/Search";

const useStyles = makeStyles(theme => ({
  paper: { width: 460, maxWidth: "100%" },
  search: { marginBottom: theme.spacing(1.5) },
  list: { maxHeight: "52vh", overflowY: "auto", margin: theme.spacing(0, -1) },
  row: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.1, 1.5),
    borderRadius: 8,
    cursor: "pointer",
    "&:hover": { background: theme.app.selectedRow },
  },
  rowActive: { background: theme.app.selectedRow, outline: `2px solid ${theme.app.lime}` },
  rowOff: { opacity: 0.5, cursor: "not-allowed", "&:hover": { background: "transparent" } },
  main: { flex: 1, minWidth: 0 },
  num: { fontWeight: 700, fontVariantNumeric: "tabular-nums", color: theme.app.ink },
  desc: { fontSize: 12.5, color: theme.app.textTertiary, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  chipCur: { backgroundColor: "#E6F4EA", color: theme.app.ok, fontWeight: 600, height: 22 },
  chipOff: { backgroundColor: theme.app.chip, color: theme.app.textSecondary, fontWeight: 600, height: 22 },
  empty: { padding: theme.spacing(4), textAlign: "center", color: theme.app.textSecondary, fontSize: 13.5 },
}));

// Seletor de número (single) no padrão do NumberPickerModal: busca + lista.
// Números já configurados na BR DID (e que não são nossos) ficam INATIVOS.
const NumberModal = ({ open, numbers, value, onClose, onPick }) => {
  const classes = useStyles();
  const [q, setQ] = useState("");

  const isLocked = n => n.configured && !n.imported; // configurado em outro lugar → indisponível

  const filtered = useMemo(() => {
    const t = q.replace(/\D/g, "");
    const s = q.trim().toLowerCase();
    return (numbers || []).filter(n =>
      (!t || n.number.includes(t)) && (!s || `${n.number} ${n.label || ""} ${n.city || ""}`.toLowerCase().includes(s))
    );
  }, [numbers, q]);

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ className: classes.paper }}>
      <DialogTitle>Escolher número de origem</DialogTitle>
      <DialogContent>
        <TextField
          className={classes.search}
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Buscar por número ou nome…"
          value={q}
          onChange={e => setQ(e.target.value)}
          autoFocus
          InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }}
        />
        <div className={classes.list}>
          {filtered.length === 0 ? (
            <div className={classes.empty}>Nenhum número encontrado.</div>
          ) : (
            filtered.map(n => {
              const off = isLocked(n);
              return (
                <div
                  key={n.number}
                  className={`${classes.row} ${n.number === value ? classes.rowActive : ""} ${off ? classes.rowOff : ""}`}
                  onClick={() => { if (!off) { onPick(n.number); onClose(); } }}
                >
                  <div className={classes.main}>
                    <div className={classes.num}>{n.number}</div>
                    <div className={classes.desc}>{[n.label, n.city].filter(Boolean).join(" · ") || "—"}</div>
                  </div>
                  {n.isDefault && <Chip label="atual" size="small" className={classes.chipCur} />}
                  {off && <Chip label="configurado" size="small" className={classes.chipOff} />}
                </div>
              );
            })
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NumberModal;
